// extracted by mini-css-extract-plugin
export default {"input":"EditSemisterForm_input__6j0h6","del":"EditSemisterForm_del__faBFL","check":"EditSemisterForm_check__tE8-b"};